module.exports = __webpack_public_path__ + "static/img/service1.a574076.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/service1.png
// module id = gkW/
// module chunks = 0